import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen gradient-bg flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full"
      >
        <Card className="p-8 border-slate-200 shadow-xl text-center" data-testid="payment-success-card">
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-12 h-12 text-emerald-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-3" style={{fontFamily: 'Manrope'}}>
            ¡Pago Exitoso!
          </h1>
          
          <p className="text-slate-600 mb-8 leading-relaxed">
            Tu pago ha sido procesado correctamente. Recibirás un comprobante por email en los próximos minutos.
          </p>
          
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-8">
            <p className="text-sm text-emerald-800">
              Tu deuda ha sido actualizada. Gracias por tu pago.
            </p>
          </div>
          
          <Button
            data-testid="back-home-button"
            onClick={() => navigate('/')}
            className="w-full bg-slate-900 hover:bg-slate-800 h-11"
          >
            Volver al Inicio
          </Button>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentSuccess;